import getDisplayName from "../../../getDisplayName";
import wrapComponent from "./wrapComponent";
import wrapSetClient from "./wrapSetClient";
import wrapTestComponent from "./wrapTestComponent";
import wrapWithReducerContext from "./wrapWithReducerContext";

const createStateRenderer = ({ apolloClient, feature, reducer }) => async (
  component,
  { noReducerWrapper, ...rendererOptions } = {}
) => {
  const module = await component;
  const EsComponent = module.__esModule ? module.default : module;
  const Component = wrapSetClient({
    Component: EsComponent,
    feature
  });
  const WrappedReducerComponent = noReducerWrapper
    ? Component
    : wrapWithReducerContext({
        Component,
        reducer
      });

  if (process.env.NODE_ENV === "test") {
    return wrapTestComponent({
      Component: WrappedReducerComponent,
      reducer,
      apolloClient,
      ...rendererOptions
    });
  }

  const WrappedComponent = wrapComponent({
    Component: WrappedReducerComponent,
    apolloClient,
    reducer,
    ...rendererOptions
  });

  const componentDisplayName = getDisplayName(EsComponent);

  WrappedComponent.displayName = `Wrapped${componentDisplayName}InApollo`;

  return WrappedComponent;
};

export default createStateRenderer;
